import { Outlet, useLocation } from "react-router-dom";
// import SideMenu from "../pos/components/SideMenu";
// import TopBar from "../pos/components/TopBar";

export default function AppLayout() {
  const location = useLocation();

  // show sidebar only for /pos routes
  const showSidebar = location.pathname.startsWith("/pos");

  return (
    <div className="flex h-screen">
      
      {/* {showSidebar && <SideMenu />} */}

      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
